import { Broker } from '../broker';

export enum SMSStatus {
  // SMSStatusNew means that the SMS ready to be sent
  SMSStatusNew = 'new',
  // SMSStatusInFlight means that the SMS has been sent to our SMS provider
  SMSStatusInFlight = 'in_flight',
  // SMSStatusSent means that the SMS that has been sent by our SMS provider to the recipient
  SMSStatusSent = 'sent',
  // SMSStatusFailed means that the SMS either failed to be sent to our SMS provider or was not sent to the recipient by the SMS provider
  SMSStatusFailed = 'failed',
}

export interface CreateSMS {
  ID?: string;
  Body: string;
  CreatedAt?: string;
  CreatorID: string;
  LoanApplicationID: string;
  TemplateID: string;
  MarketCountry: string;
  LoanQuoteID?: string;
  FollowupAt?: string;
  ResolvedAt?: string;
  CustomerID: string;
  Transactional: boolean;
  Source: string;
  Meta: {
    Broker?: Broker;
    Brand?: string;
  };
}

export interface SMS extends CreateSMS {
  ID: string;
  CreatedAt: string;
  UpdatedAt?: string;
  SentAt?: string;
  Inbound: boolean;
  CustomerPhoneNumber: string;
  ProviderMessageID: string;
  Status: SMSStatus;
  ErrorMessage: string;
}

export interface SMSTemplate {
  ID: string;
  Broker: Broker;
  MarketCountry: string;
  Name: string;
  Body: string;
  CreatedAt: string;
  UpdatedAt: string;
  Active: boolean;
  AllowsCustomContent: boolean;
  Transactional: boolean;
}

export type SMSFindInput = {
  LoanApplicationID?: string;
  MarketCountry?: string;
  CustomerID?: string;
  CustomerPhoneNumber?: string;
  ProviderMessageID?: string;
  Limit?: number;
  Offset?: number;
};
